module.exports = __webpack_public_path__ + "static/media/realtalk_sd_rei087d7e92ed9bcdea06c3e5224efe1988.webp";